<template>
  <div id="administrativeDetail">
    <div id="header">
      <div class="swiper-container swiperf">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in divisionInfo.fileList" :key="item.id"><img :src="item.fileUrl" alt=""></div>
        </div>
      </div>
      <div id="bar">
        <breadcrumb msg="科室导览" msg1="科室介绍"></breadcrumb>
      </div>
    </div>
    <swiperS :doctorList="divisionInfo.doctorForms" src="医生团队"></swiperS>
    <div id="doctorDetail">
      <div style="font-size:22px">
        <img style="margin-right:15px" src="../assets/img/arr2.png" alt srcset />科室信息
      </div>
      <div id="doctorDetailBody">
        <div id="doctorDetailBodyImg">
          <img style="width: 12.5rem;height: 12.5rem" :src="divisionInfo.fileList?divisionInfo.fileList[0].fileUrl :'../assets/img/s5e0866a322355.jpg'" alt=" " />
        </div>
        <div id="doctorDetailBodyText">
          <div>{{divisionInfo.name}}</div>
          <p v-html="divisionInfo.introduction" style="text-indent: 2rem;"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import swiperS from "../components/swiper";
  import "../../node_modules/swiper/css/swiper.css";
  import Swiper from "swiper";
  import "../../node_modules/swiper/css/swiper.css";
  import breadcrumb from "../components/breadcrumb1";
  import { divisionInfo } from "../../api/api.js";

  export default {
    components: { swiperS, breadcrumb },
    data() {
      return {
        divisionInfo: {}
      };
    },
    created() {
      if (this.$route.query.id) {
        // this.getInfo(this.$route.query.id)
      }
    },
    mounted() {
      this.getInfo(this.$route.query.id);
      var mySwiper = new Swiper(".swiperf", {
        autoplay: true //可选选项，自动滑动
      });
    },
    methods: {
      getInfo(id) {
        divisionInfo({ id: id }).then(res => {
          if (res.data.code === 200) {
            this.divisionInfo = res.data.data;
            // this.divisionInfo.introduction.replace(' ','<br/>')
            console.log(this.divisionInfo)
          }
        });
      }
    }
  };
</script>
<style lang="less">
  #administrativeDetail {
    /deep/ #address {
      color:rgb(69,109,171) ;

    }
    /deep/ .el-breadcrumb__inner {
      color:rgb(69,109,171) ;
    }
      /deep/ .el-breadcrumb__inner a,
      .el-breadcrumb__inner.is-link {
        color: rgb(69,109,171)  !important;
      }
      /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        color: rgb(69,109,171)  !important;
        font-weight: 600 !important;
      }
      /deep/ .el-breadcrumb__separator {
        color: rgb(69,109,171)  !important;
      }
  }
</style>
<style lang="less" scoped>
  #administrativeDetail {
    background-image: url(../assets/img/jkjt3.jpg);
    position: relative;
    z-index: -2;
    #header {
      height: 650px;
      width: 100%;
      position: relative;
      // background-image: url(../assets/img/s5dee0acddfbef.jpg);
      // background-size: 100% 100%;
    }
    #bar{
      position: relative;
      z-index: 2;
      width:1200px;
      margin:0 auto;
      height:40px;
    }
    .swiperf{
      // position: absolute;
      // top: 83px;
      width: 100%;
      height: 500px;
      z-index: 1;
      img{
        height: 100%;
        width: 100%;
      }
    }
    #doctorDetail {
      width: 1200px;
      margin: 0 auto;
      // height: 400px;
      margin-top: 40px;
      color: black;
      #doctorDetailBody {
        display: flex;
        flex-direction: row;
        #doctorDetailBodyImg {
          width: 380px;
          padding: 30px;
        }
        #doctorDetailBodyText {
          padding: 40px 50px;
          div {
            font-size: 24px;
          }
          p {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>
